import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { pickemsMarket } from "../models/pickems";
import { useMemo } from "react";
import { transformPickemsMarkets } from "./shared";
import type { Always } from "types/utilities";

export const usePickemsMarkets = (contestId: string) => {
  const { data, isLoading, error } = useFirestore(
    contestId && `/pickemsContests/${contestId}/markets`,
    pickemsMarket.array(),
  );

  const transformedMarkets = useMemo(() => {
    if (!data) return [];

    const markets = transformPickemsMarkets(data);

    markets.sort((a, b) => {
      if (!a.event.scheduledStartTime || !b.event.scheduledStartTime) {
        return 1;
      }

      if (a.event.scheduledStartTime < b.event.scheduledStartTime) {
        return -1;
      }

      return 1;
    });

    return markets;
  }, [data]);

  return { markets: transformedMarkets, isLoading, error } as const;
};

export type PickemsMarket = Always<
  ReturnType<typeof usePickemsMarkets>["markets"][number]
>;
